// extracted by mini-css-extract-plugin
module.exports = {"normal":"Select_normal__1gy3A","label":"Select_label__3tY_6","select":"Select_select__3gv9M","options":"Select_options__37A-G"};